import { render, staticRenderFns } from "./report-incident-page.vue?vue&type=template&id=b8a45df4&"
import script from "./report-incident-page.vue?vue&type=script&lang=js&"
export * from "./report-incident-page.vue?vue&type=script&lang=js&"
import style0 from "./report-incident-page.vue?vue&type=style&index=0&id=b8a45df4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports